/* Lightweight SPA SEO helpers. */

/* Toggle a robots noindex meta for thin/auto-generated pages (Feb-2026 site
   review): pages without substantial original content should not be indexed.
   Call setNoindex(false) in the effect cleanup so navigation resets it. */
export function setNoindex(on) {
  let m = document.querySelector('meta[name="robots"][data-dynamic="1"]');
  if (on) {
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      m.setAttribute("data-dynamic", "1");
      document.head.appendChild(m);
    }
    m.setAttribute("content", "noindex, follow");
  } else if (m) {
    m.remove();
  }
}
